import { useEffect, useState } from "react";

/**
 * useLocalState — a useState that syncs to localStorage.
 * Reads the initial value from localStorage (if present and parseable)
 * and writes on every change. Fails silently if storage is unavailable
 * (e.g. private browsing, disabled).
 */
export default function useLocalState(key, initial) {
  const [value, setValue] = useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      if (raw == null) return initial;
      return JSON.parse(raw);
    } catch {
      return initial;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // storage unavailable — no-op
    }
  }, [key, value]);

  const clear = () => {
    try {
      window.localStorage.removeItem(key);
    } catch {
      // no-op
    }
    setValue(initial);
  };

  return [value, setValue, clear];
}
